// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__hPoKi","text":"Footer_text__dFY2z"};